import { useLayoutEffect, useRef, type RefObject } from 'react';

export default function useResize(
    ref: RefObject<HTMLElement>,
    onResize: (rect: DOMRectReadOnly) => void,
) {
    const onResizeRef = useRef(onResize);
    onResizeRef.current = onResize;

    // biome-ignore lint/correctness/useExhaustiveDependencies:
    useLayoutEffect(() => {
        const el = ref.current;
        const resizeObserver = new ResizeObserver(entries =>
            window.requestAnimationFrame(() => {
                for (const entry of entries) {
                    onResizeRef.current?.(entry.contentRect || {});
                }
            }),
        );

        if (el) {
            onResizeRef.current?.(el.getBoundingClientRect() || {});
            resizeObserver.observe(el);
        }

        return () => {
            if (el) {
                resizeObserver.unobserve(el);
            } else {
                resizeObserver.disconnect();
            }
        };
    }, []);
}
